import { Button as MuiButton } from '@mui/material'

import type { ButtonProps } from './Button.types'

const Button = ({ height = '58px', radius = '18px', sx, disabled, ...props }: ButtonProps) => {
  return (
    <MuiButton
      variant="contained"
      disabled={disabled}
      sx={{
        height,
        borderRadius: radius,
        backgroundColor: disabled ? '#E5E5E7' : '#5BC06B',
        color: disabled ? '#A3A5A9' : '#F5F5F7',
        fontSize: '16px',
        fontWeight: 500,
        textTransform: 'none',
        boxShadow: disabled ? 'none' : '0px 3px 9px 0px rgba(0, 0, 0, 0.18)',
        '&:hover': {
          backgroundColor: disabled ? '#E5E5E7' : '#4DAF5C',
          boxShadow: disabled ? 'none' : '0px 3px 9px 0px rgba(0, 0, 0, 0.18)',
        },
        '&:active': {
          boxShadow: disabled ? 'none' : '0px 3px 9px 0px rgba(0, 0, 0, 0.18)',
        },
        '&.Mui-disabled': {
          backgroundColor: '#E5E5E7',
          color: '#A3A5A9',
          boxShadow: 'none',
        },
        paddingX: 4.5,
        ...sx,
      }}
      {...props}
    />
  )
}

export default Button
